<template>
	<component
		:is="mainComponent.is"
		v-bind="mainComponent.props"
		v-on="mainComponent.events"
	>
		<template #activator="{ on }">
			<slot name="activator" :on="on" />
		</template>

		<slot />
	</component>
</template>

<script>
import { VDialog, VBottomSheet } from 'vuetify/lib';

export default {
	name: 'SModalBottomSheet',
	components: { VDialog, VBottomSheet },
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		persistent: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		mainComponent() {
			const isMobile = this.$vuetify.breakpoint.xsOnly;
			return {
				is: isMobile
					? 'VBottomSheet'
					: 'VDialog',
				props: {
					value: this.value,
					maxWidth: 600,
					persistent: this.persistent,
					scrollable: true,
				},
				events: {
					'input': event => this.$emit('input', event),
				},
			};
		},
	},
};
</script>

<style scoped>

</style>
